import React from "react";
import { Typography, IconButton } from "@material-ui/core";
import DriveEtaIcon from "@material-ui/icons/DriveEta";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import "./VehicleSummaryCard.css";

type VehicleSummaryCardProps = {
  plate: string;
  vehicleInfo?: string;
  isActionsDisabled: boolean;
  /** El vehículo lo impone la autorización: no se puede editar ni borrar. */
  hideActions?: boolean;
  onEdit: () => void;
  onDelete: () => void;
};

/** Resumen de un vehículo con acciones de editar y quitar. Lo usan tanto los vehículos asociados
 * (acoplados) como el vehículo del transportista. */
const VehicleSummaryCard: React.FC<VehicleSummaryCardProps> = ({
  plate,
  vehicleInfo,
  isActionsDisabled,
  hideActions = false,
  onEdit,
  onDelete,
}) => {
  return (
    <div className="vehicleAssociatedVehicleSummary">
      <div className="vehicleAssociatedVehicleSummaryContent">
        <DriveEtaIcon className="vehicleAssociatedVehicleSummaryIcon" />
        <div className="vehicleAssociatedVehicleSummaryInfo">
          <Typography className="vehicleAssociatedVehicleSummaryName">{plate}</Typography>
          {vehicleInfo && (
            <Typography className="vehicleAssociatedVehicleSummaryDoc">{vehicleInfo}</Typography>
          )}
        </div>
      </div>
      {hideActions ? null : (
        <div className="vehicleAssociatedVehicleSummaryActions">
          <IconButton
            className="vehicleAssociatedVehicleSummaryActionButton"
            onClick={onEdit}
            disabled={isActionsDisabled}
          >
            <EditOutlinedIcon />
          </IconButton>
          <IconButton
            className="vehicleAssociatedVehicleSummaryActionButton"
            onClick={onDelete}
            disabled={isActionsDisabled}
          >
            <DeleteOutlineIcon style={{ color: "#ef4444" }} />
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default VehicleSummaryCard;
